<script setup>

import { computed } from 'vue';
import { getSection } from '@/scripts/navigationRapport.js';
import ElementFilAriane from './ElementFilAriane.vue';

const { sectionPrincipale, sectionSelectionnee } = defineProps({
	sectionPrincipale: Object,
    sectionSelectionnee: Object
});

const sectionsChainees = computed(() => {
    const sections = [];
    if (sectionSelectionnee) {
        const positionSection = sectionSelectionnee.positionSection.slice();
        while (positionSection.length > 0) {
            sections.unshift(getSection(positionSection, sectionPrincipale));
            positionSection.pop();
        }
    }
    sections.unshift(sectionPrincipale);
    return sections;
});

</script>

<template>
    <div class="fil-ariane-section">
        <ElementFilAriane v-for="section in sectionsChainees" :section="section" :selectionnee="section === sectionSelectionnee" />
    </div>
</template>

<style scoped>

.fil-ariane-section {
    display: flex;
    flex-direction: row;
    background-color: rgb(249, 249, 249);
    border-bottom:  2px inset whitesmoke;
}

</style>